import fetch from 'isomorphic-fetch';
import { checkStatus } from '../../util';
import { ROOT } from '../../../constants/root';

export function getFolders(projeto) {
	return function(dispatch, getState) {		

		var URL = `${ROOT}/folder/`;
		if (projeto) {
			URL = `${ROOT}/folder/${projeto}/`;		
		}

		return fetch(URL, {
			method: 'GET',
			headers: {
				'Authorization': 'Token ' + getState().login.credentials.token,
				'Content-Type': 'application/json'
			}
		})
		.then((response) => checkStatus(response, dispatch))
		.then((response) => response.json())
		.then((json) => {
			dispatch(setFoldersList(json));
		})
		.catch((e) => {
			console.error(e);
		});
	};
}

function setFoldersList(folders) {
	return {
		type: "SET_FOLDERS_LIST",
		folders
	};	
}


// WEBPACK FOOTER //
// ./src/state/domains/folders/actions.js